import React, { useContext } from "react";
import { Skeleton } from "primereact/skeleton";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";

function ContactDashBoardHeader() {
  const { contactFirstName, isOpen } = useContext(ContactProfileDetailsContext);
  return (
    <div
      style={{
        height: "80px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="w-full fixed z-50 border-b-1 border-[#DEE2E6]"
    >
      <div className={`h-full  ${isOpen ? "w-63 mr-6" : "w-32 mr-4"}`} />
      <div className="h-full" style={{ flex: isOpen ? 4 : 6 }}>
        <div className="flex justify-between items-center h-full conthrax-font border-b-1 border-[#DEE2E6]">
          {contactFirstName ? (
            <p className="text-2xl font-semibold py-3 ml-2 text-[#0A090B]">
              {`Welcome Back, ${contactFirstName}!`}
            </p>
          ) : (
            <Skeleton width="20rem" height="3rem" borderRadius="16px" className="mb-2" />
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactDashBoardHeader;
